import { asset } from "@/lib/asset";
const Banner = () => {
    return (
        <div className="w-full xl:w-[1170px] h-auto flex-col justify-start items-center gap-10 inline-flex">

            <div className="w-full xl:w-[253px] h-auto xl:h-[161px] justify-center items-center flex lg:hidden">
                <img className="w-[150px] h-[95px]" src={asset("/img/ka.svg")} />
            </div>

            <div className="self-stretch h-11 text-center bg-gradient-to-r from-[#6082A0] to-[#E55961] text-transparent bg-clip-text text-base leading-normal text-[24px] xl:text-[32px] xl:leading-[44.8px] font-extrabold font-['Open Sans']">
                Cотрудничество с Ключ-АСТРОМ <br />
            </div>

            <div className="self-stretch justify-center items-start gap-[40px] lg:gap-[0px] flex xl:w-[1170px] xxl:w-[1400px] mt-[40px]">

                <div className="w-full lg:w-[418px] h-full justify-start items-start flex hidden lg:flex flex-row">
                    <img className="w-full lg:w-[253px] h-auto xl:pl-[100px]" src={asset("/img/ka.svg")} />
                </div>

                <div className="w-full lg:w-[751px] text-[#58493b] text-16px[] lg:text-[20px] text-center lg:text-left font-normal font-['Open Sans']">
                    <div className="w-full text-[#59493B]">
                        Компания «Рускомтехнологии» проводит работу по созданию сети
                        партнеров на территории России, Белоруссии и Казахстана.
                        APM на базе ИИ — это неограниченные возможности, которые усиливают любую технологию.
                        Наши партнеры расширяют своивозможности, обучаются новым подходам и умножают экспертизу.
                        Мы поддерживаем партнеров на всех уровнях: пресейл, внедрение решения, обучение заказчика и сопровождение проекта.
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Banner;